import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import LandingBgTile from '@/assets/img/LandingBgTile.png';
import CloseButton from '../UIKit/CloseButton';

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  content: {
    inset: 'unset',
    minWidth: '430px',
    minHeight: '400px',
    background: `url(${LandingBgTile})`,
    backgroundRepeat: 'repeat !important',
    // Для корректной работы контрола select в параметрах командного режима src\styledComponents\render\SimulatorParams\index.js
    position: 'relative',
    overflow: 'visible !important',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '20px',
    border: '0',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    padding: '50px',
  },
};
/**
 *
 * @param {boolean} show - отобразить элемент
 * @param {boolean} close - onCloseEvent возникает при попытке закрыть модальное окно
 * @param {object} children - содержимое модального окна
 * @param {string} closeType - вид кнопки, circle - круг, red - красная кнопка с надписью "CLOSE"
 * @returns {React.Component} - модальное окно
 */
function ModalComponent({ show, close, children, closeType }) {
  const [open, setOpen] = useState(show != null ? show : true);

  useEffect(() => {
    if (show != null) {
      setOpen(show);
    }
  }, [show]);

  const closeHandler = () => {
    if (close != null) {
      close();
    } else {
      setOpen(!open);
    }
  };

  const overlayClose = () => {
    closeHandler();
  };

  return (
    <>
      {open && (
        <Modal isOpen style={modalStyle} onRequestClose={overlayClose}>
          {closeType === 'circle' && <CloseButton onClick={closeHandler} />}
          {closeType === 'red' && (
            <button
              type="button"
              onClick={closeHandler}
              className="btn-type-1 btn-size-8 btn-stop"
              style={{
                position: 'absolute',
                top: 15,
                right: 15,
                zIndex: 20,
              }}
            >
              <span>
                <FormattedMessage id="CLOSE" defaultMessage="" />
              </span>
            </button>
          )}
          {children}
        </Modal>
      )}
    </>
  );
}

ModalComponent.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  closeType: PropTypes.string,
};

ModalComponent.defaultProps = {
  closeType: 'circle',
};

export default ModalComponent;
